import React, { useState, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import AccordionReact from 'devextreme-react/accordion';
import InventoryGrid from "./InventoryGrid";
import { Button } from 'devextreme-react/button';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { SelectBox } from "devextreme-react";

const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];
function InventorySearchForm(props) {
  var accessToken = props.oidc.user.access_token;
  const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
  const [selectedTab, setSelectedTab] = useState(props.selectedTab);
  const [searchPanelStatus, setSearchPanelStatus] = useState(true);
  const [selectedLocation, setLocation] = useState('');
  const [selectedSite, setSite] = useState('');
  const [isMobileView, setIsMobileView] = useState(false);

  const SHIPPER_ID_TO = "shipperidto";
  const lookups = {};
  lookups[SHIPPER_ID_TO] = {
    name: "ShipperTo",
    label: "Ship To:",
    lookupType: 5
  };
  const locations = [
    { id: 1, name: 'Location A', value: 'A' },
    { id: 2, name: 'Location B', value: 'B' },
    { id: 3, name: 'Location C', value: 'C' },
    { id: 4, name: 'Location D', value: 'D' },
  ];
  const sites = [
    { id: 1, name: 'Site A', value: 'A' },
    { id: 2, name: 'Site B', value: 'B' },
    { id: 3, name: 'Site C', value: 'C' },
    { id: 4, name: 'Site D', value: 'D' },
  ];
  const dataSource = [
    { id: 1, item: 'Item 1', size: 'Size 1', onHand: '31', operations: 1, targetLocation: 'Location 1', quantity: 12322 },
    { id: 2, item: 'Item 2', size: 'Size 2', onHand: '22', operations: 2, targetLocation: 'Location 2', quantity: 21212 },
    { id: 3, item: 'Item 3', size: 'Size 3', onHand: '13', operations: 3, targetLocation: 'Location 3', quantity: 14 },
    { id: 4, item: 'Item 4', size: 'Size 4', onHand: '44', operations: 4, targetLocation: 'Location 4', quantity: 4345 },
  ]
  const selectionChanged = useCallback(
    (e, tg) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        return newStatus;
      });
    },
    [selectedItems, setSelectedItems],
  );

  const onSearchTransaction = async (e) => {
    e.preventDefault();
  };
  const handelSearch = (e) => {
    e.event.stopPropagation();
  }


  const handelReset = (e) => {
    try {
      e.event.stopPropagation();
    }
    catch (error) {
    }
    finally {
    }
  }
  const updateView = () => {
    setIsMobileView(window.innerWidth <= 768);
  };
  useEffect(() => {
    updateView();
    window.addEventListener("resize", updateView);
    return () => {
      window.removeEventListener("resize", updateView);
    };
  }, []);
  return (
    <div>
      <div className="row">
        <div className="col-md-12 main-page" >
          <div id="accordion" >
            <form onSubmit={(e) => onSearchTransaction(e)}>

              <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={e => {
                  if (e.currentTarget === e.target) {
                    selectionChanged(e, e.target);
                  }
                }}
                itemTitleRender={() => (

                  <Toolbar className="accordian-toolbar">
                    <Item location="before" >
                      <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          Buscar Inventario
                        </h6>
                      </div>
                    </Item>

                    <Item location="after" visible={!isMobileView}>
                      <Button className="accordianButton" onClick={handelSearch} text="Buscar/Search" type="default" />
                    </Item>
                    <Item location="after" visible={!isMobileView}>
                      <Button className="accordianButton" onClick={handelReset} text="Restablecer/Reset" />
                    </Item>


                  </Toolbar>
                )}
                itemRender={(itemProps) => (
                  <div>
                    <div className="row">
                      <div className="col-md-6">
                        <SelectBox
                          dataSource={sites}
                          value={selectedSite}
                          stylingMode="outlined"
                          labelMode="static"
                          label="Elegir Sitio / Choose Site"
                          displayExpr="name"
                          valueExpr="value"
                          onValueChanged={(e) => setSite(e.value)}
                        />
                      </div>
                      <div className="col-md-6">
                        <SelectBox
                          dataSource={locations}
                          value={selectedLocation}
                          stylingMode="outlined"
                          labelMode="static"
                          label="Elegir Ubicación / Choose Location"
                          displayExpr="name"
                          valueExpr="value"
                          onValueChanged={(e) => setLocation(e.value)}
                        />
                      </div>
                    </div>
                    <div className="row accordianLastRow" visible={isMobileView}>
                      <div className="col-md-12">
                        <Button className="accordianButton" onClick={handelSearch}visible={isMobileView} text="Buscar" type="default" />
                        <Button className="accordianButton" onClick={handelReset} visible={isMobileView}text="Restablecer" />
                      </div>
                    </div>
                  </div>
                )}
                id="accordion-container" className="accordion-height"
              />
            </form>
            <InventoryGrid
              data={dataSource}
              searchPanelStatus={searchPanelStatus}
              selectedTab={selectedTab}
              initialDisableButton={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(InventorySearchForm);